module.exports = __webpack_public_path__ + "static/coronavirus-about-a26e67788bb553a4d9f774e39deecb78.jpg";